import { gql } from 'apollo-boost';

export const GET_ACTIVE_PLANS = gql`
  query {
    getActivePlans {
      subscriptions {      
        id
        name
        description
        benefits { id kind translationKey fallback value valueSource }
        benefitListId
        benefitList { id name en de revision translations { language lines } }
        stripePriceId
        type
        planType
        price
        anchorPrice
        active
        currency
        maxCredits
        maxMessages
        maxStorage
        maxFileSize
        featureLimits {
          slackConnections
        }
        revenueCatApiId
        revenueCatProductId
        landing
        landingDescription
        android
        ios
        web
        stripePaymentLink
        stripeTrialDays
        stripeIntroPriceId
        index
        tag
        limitedOffer {
          text
          endDate
          isActive
        }
      }
      oneTimePurchases {
        id
        name
        description
        benefits { id kind translationKey fallback value valueSource }
        benefitListId
        benefitList { id name en de revision translations { language lines } }
        stripePriceId
        type
        planType
        price
        anchorPrice
        active
        currency
        maxCredits
        maxMessages
        maxStorage
        maxFileSize
        featureLimits {
          slackConnections
        }
        revenueCatApiId
        revenueCatProductId
        landing
        landingDescription
        android
        ios
        web
        stripePaymentLink
        tag
        limitedOffer {
          text
          endDate
          isActive
        }
      }
      oneTimeDeals {
        id
        name
        description
        benefits { id kind translationKey fallback value valueSource }
        benefitListId
        benefitList { id name en de revision translations { language lines } }
        stripePriceId
        type
        planType
        price
        anchorPrice
        active
        currency
        maxCredits
        maxMessages
        maxStorage
        maxFileSize
        featureLimits {
          slackConnections
        }
        revenueCatApiId
        revenueCatProductId
        landing
        landingDescription
        android
        ios
        web
        stripePaymentLink
        index
        tag
        limitedOffer {
          text
          endDate
          isActive
        }
      }
    }
  }
`;
